import React, { useState } from 'react'
import "../styles/stopRegistration.scss"
import { useNotification } from '../context/notificationContext'
import { axiosInstance } from '../services/axiosInstance'

const StopRegistration = ({setShow}) => {
    const [,,showNotification] = useNotification()
    const [email, setEmail] = useState("")
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (e) => {
      e.preventDefault();
      if (!email) {
        return showNotification("warning", "Please enter your email");
      } else {
        setIsLoading(true);
        axiosInstance
          .post("/contact", {
            subject: "SSB GPT - 📩 New Early Access Signup",
            message: `<p style="margin: 0">Hello Admin</p> 
                      <p style="margin: 0">You’ve received a new early access signup. Here are the details:</p>
                      <p style="margin: 10px 0"><b>Email: ${email}</b></p>
                      <p style="margin: 0">Please keep this information safe and add it to the early access list.</p>
                      <p style="margin: 10px 0 0">Best regards</p>
                      <p style="margin: 0">SSB GPT</p>`,
          })
          .then((res) => {
            console.log(res?.data);
            setShow(false);
            setEmail("");
            return showNotification(
              "success",
              "Thank you! You’ll be notified when we’re live."
            );
          })
          .catch((err) => {
            console.log(err);
            return showNotification("error", err?.response?.data?.message || err?.message);
          }).finally(() => {
            setIsLoading(false);
          });
      }
    };

  return (
    <div className='stop_registration_main'>
        <div className="title">🚧 We're Working Behind the Scenes!</div>
        <p className="description">We’re currently upgrading our platform to bring you an even better experience. New registrations are temporarily closed, but you can drop your email to be among the first to know when we go live!</p>
        <form>
          <input type="email" placeholder='Enter Your email' required value={email} onChange={(e)=> setEmail(e.target.value)} />
          <button type='submit' onClick={handleSubmit}>{isLoading ? "Loading..." : "Submit"}</button>
        </form>
    </div>
  )
}

export default StopRegistration